import clsx from 'clsx';
import { makeStyles, Paper, Theme } from '@material-ui/core';
import { InfoCompPanelHeader, useModePanelStyle } from '@moderepo/mode-app-components';


const useStyle = makeStyles((theme: Theme) => {
    return {
        textArea: {
            width     : '100%',
            height    : '100%',
            resize    : 'vertical',
            overflow  : 'auto',
            whiteSpace: 'pre',
            padding   : theme.spacing(1),
            border    : `1px solid ${theme.palette.divider}`,
            background: 'none',
            color     : theme.palette.text.primary,

        },
    };
});


interface ProjectTranslationContainerProps {
    readonly translationJSON: string;
    readonly className?: string | undefined;
}


export const ProjectTranslationContainer = (props: ProjectTranslationContainerProps) => {
    const { translationJSON } = props;
    const panelClasses = useModePanelStyle();

    const classes = useStyle();

    return (
        <Paper
            elevation={2}
            className={clsx(panelClasses.root, props.className)}
        >
            <InfoCompPanelHeader
                icon="widgets"
                title="Project Translation JSON"
            />
            <textarea
                readOnly
                className={clsx(classes.textArea)}
                value={translationJSON}
                onChange={() => {}}
            />
        </Paper>
    );
};
